export default __webpack_public_path__ + "static/media/cross.b5b2175c.svg";